const shopUpdate = () => import('@/views/main/shop/update/update.vue')
export default {
  path: '/main/shop/update',
  name: 'shopLUpdate',
  component: shopUpdate,
  children: []
}
